module.exports = __webpack_public_path__ + "static/img/img_4.8aae1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_4.jpg
// module id = b4SF
// module chunks = 0